import * as React from 'react';
import * as ReactDOM from 'react-dom';

export const Portal: React.FC<React.PropsWithChildren> = props => {
  /* istanbul ignore next */
  if (typeof window === 'undefined') {
    return null;
  }

  const body = document.querySelector('body') as HTMLBodyElement;

  return ReactDOM.createPortal(props.children, body);
};
